import { DataProvider } from '@/common/models';

const LIFESIGHT_PROVIDER_CODE = 'LIFESIGHT';
const CENSUS_PROVIDER_CODE = 'CENSUS';

export enum DataProviderCodes {
  EPSILON = 'EPSILON',
  ADSQUARE = 'ADSQUARE-EU',
  LIFESIGHT_NA = `${LIFESIGHT_PROVIDER_CODE}_NA`,
  LIFESIGHT_EU = `${LIFESIGHT_PROVIDER_CODE}_EU`,
  KANTAR = 'KANTAR',
  SCENTRE = 'SCENTRE',
  LIVEBOARD = 'LIVE-BOARD',
  CENSUS_USA = `${CENSUS_PROVIDER_CODE}_USA`,
  STROEER = 'STROEER',
  NEXIGA = 'NEXIGA',
  ENVIRONICS = 'ENVIRONICS',
  MASTERCARD = 'MASTERCARD',
}

export function isLifesightDataProvider(dp: DataProvider): boolean {
  return dp.code.startsWith(LIFESIGHT_PROVIDER_CODE);
}

export function isCensusDataProvider(dp: DataProvider): boolean {
  const dataProviders = [
    DataProviderCodes.NEXIGA,
    DataProviderCodes.ENVIRONICS,
    LIFESIGHT_PROVIDER_CODE,
    CENSUS_PROVIDER_CODE,
  ];
  return dataProviders.some((provider) => dp.code.startsWith(provider));
}
